module.exports = __webpack_public_path__ + "static/media/globe.b95f636f.png";